module.exports = __webpack_public_path__ + "static/media/not-found.cd9da261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/not-found/not-found.svg
// module id = 969
// module chunks = 1